<template>
  <span>
    <slot :items="items" :isBusy="isBusy"/>
  </span>
</template>

<script>
import Api from '@/providers/Api';

export default {
  name: 'SurveysDataProvider',
  props: {
    type: {
      required: true,
      validator: (prop) => ['active', 'upcoming', 'completed'].includes(prop),
    },
    societyId: {
      required: true,
      type: [Number, String],
    },
    isGmAdminType: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isBusy: false,
      items: [],
    };
  },
  created: function () {
    this.getItems();
  },
  methods: {
    getItems: async function () {
      this.isBusy = true;
      let promise;
      if (this.type === 'active') {
        promise = Api.adminGetActiveSurveys(this.societyId, this.isGmAdminType);
      } else if (this.type === 'upcoming') {
        promise = Api.adminGetUpcomingSurveys(this.societyId, this.isGmAdminType);
      } else if (this.type === 'completed') {
        promise = Api.adminGetCompletedSurveys(this.societyId, this.isGmAdminType);
      } else {
        return;
      }
      try {
        this.items = await promise;
      } catch (error) {
        this.$toasted.error('Server error.', {
          duration: 3000,
        });
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
